import {useTheme, css} from "@emotion/react";
import PropTypes from "prop-types";

import useBreakpoints from "@util/breakpoints";
import CmsImageLoader from "../base/CmsImageLoader";
import { ButtonPill, Text, Kicker } from "@/base";

const FlagBlade = ({
  align_image,
  image,
  kicker,
  call_to_action,
  text,
}) => {
  const theme = useTheme();
  const baseTheme = theme.base.fontFamily;

  const imgStyle = useBreakpoints([theme.breakpoint.md])({
    minHeight: ['660px', '770px']
  });

  const textStyles = css(`
    font-theme: ${baseTheme};
  `);

  const direction =  align_image.value === "left" ? "fade-left" : "fade-right";

  let delays = [
    (kicker && kicker.value ? 200 : 0),
    (text && text.value ? (kicker && kicker.value ? 400 : 200) : 0),
    (text && text.value ? (kicker && kicker.value ? 600 : 400) : 200),
  ];

  const align = align_image?.value === "right" ? "flex-md-row-reverse" : "flex-md-row";

  return (
      <div className={`d-flex flex-column ${align}`}>

        <div css={imgStyle} className={'size-full size-md-1of2 posRelative'}>
          {image && (
              <CmsImageLoader className={'img-fill'} url={image.image_url && image.image_url.value}
                              alt={image.alt_text && image.alt_text.value}
                              data-aos={"zoom-in"} data-aos-anchor-placement={"center-bottom"}/>
          )}

        </div>

        <div className={'container py-4 size-full size-md-1of2 d-flex flex-column justify-content-center'}>
          {kicker?.value && (
              <Kicker>
                <div data-aos={direction} data-aos-delay={delays[0]}>{kicker.value}</div>
              </Kicker>
          )}

          {text?.value && (
              <Text>
                <div data-aos={direction} data-aos-delay={delays[1]} css={textStyles} dangerouslySetInnerHTML={{ __html: text.value }} />
              </Text>
          )}
          {call_to_action?.button_text && (
              <span>
                <ButtonPill to={call_to_action?.button_url.value}
                            data-aos={direction} data-aos-delay={delays[2]}>{call_to_action.button_text.value}</ButtonPill>
              </span>
          )}
        </div>

      </div>
  );
};

FlagBlade.propTypes = {
  align_image: PropTypes.object,
  image: PropTypes.object,
  banner_title: PropTypes.object,
  banner_subtitle: PropTypes.object,
  kicker: PropTypes.object,
  call_to_action: PropTypes.object,
  text: PropTypes.object,
};

export default FlagBlade;
